import { useState, useRef, useEffect } from "react";
import { CaretDown, Globe } from "@phosphor-icons/react";
import { useLang } from "../i18n/LanguageContext";

export default function LanguageSwitcher({ variant = "dark" }) {
  const { lang, setLang, languages } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = languages.find((l) => l.code === lang) || languages[0];

  const triggerClass =
    variant === "dark"
      ? "text-[#D4AF37] hover:text-[#E8C75A] border border-[#D4AF37]/40 hover:border-[#D4AF37]"
      : "text-[#1E3A5F] hover:text-[#15273F] border border-[#1E3A5F]/40 hover:border-[#1E3A5F]";

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="lang-switcher-toggle"
        onClick={() => setOpen(!open)}
        className={`flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-mono uppercase tracking-widest transition-colors ${triggerClass}`}
        aria-label="Change language"
      >
        <Globe size={14} weight="bold" />
        {current.label}
        <CaretDown size={10} weight="bold" className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div
          data-testid="lang-switcher-menu"
          className="absolute right-0 mt-2 min-w-[140px] bg-white border border-[#D5DEE8] shadow-lg z-50"
        >
          {languages.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              className={`w-full text-left px-4 py-2 text-sm transition-colors ${
                l.code === lang
                  ? "bg-[#1E3A5F] text-[#D4AF37] font-semibold"
                  : "text-[#0F1E33] hover:bg-[#D6E2F0]"
              }`}
            >
              <span className="font-mono text-[10px] tracking-widest mr-2">{l.label}</span>
              {l.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
